<template>
    <div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize" >
            <el-form-item label="角色名称">
                <el-input v-model="formInline.roleName" placeholder="角色名称" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="getList">查询</el-button>
                <el-button type="success" @click="handleAdd">新增</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="dataList" stripe border center :size="GCONFIG.styleTableSize"  v-loading="loading">
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column prop="roleId" label="角色标示"></el-table-column>
            <el-table-column prop="roleName" label="角色名"></el-table-column>
            <el-table-column prop="status" :formatter="convertStatus" label="状态"></el-table-column>
            <el-table-column prop="platformGroupName" label="所属公司"></el-table-column>
            <el-table-column label="操作" fixed="right" width="230">
                <template slot-scope="scope">
                    <el-button type="warning " size="mini" @click="handleUpdate(scope.row)">修改</el-button>
                    <el-button type="success " size="mini" @click="handleMenu(scope.row)">菜单</el-button>
                    <el-button type="success " size="mini" @click="handleResource(scope.row)">资源</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-wrap">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formInline.currentPage"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formInline.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="formInline.recordsTotal">
            </el-pagination>
        </div>
        <el-dialog title="管理" :visible.sync="dialogFormVisible" center>
            <el-form :model="form" label-width="120px">
                <el-form-item label="角色名" :required="true">
                    <el-input v-model="form.roleName" placeholder="角色名" clearable></el-input>
                </el-form-item>
                <el-form-item label="状态">
                    <el-select :popper-append-to-body="true" v-model="form.status">
                        <el-option
                                v-for="item in statusList"
                                :key="item.value"
                                :label="item.name"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="所属公司">
                    <el-select :popper-append-to-body="true" v-model="form.platformGroupId">
                        <el-option
                                v-for="item in platFormGroupList"
                                :key="item.platformGroupId"
                                :label="item.platformGroupName"
                                :value="item.platformGroupId">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="updateOrAdd">确 定</el-button>
            </div>
        </el-dialog>


        <el-dialog  title="角色菜单/资源管理" :visible.sync="dialogFormVisible1" center :fullscreen="true">
            <el-form :inline="true" :model="formInline1" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize">
                <el-form-item>
                    <el-button type="primary" @click="getMallRoleResourceList">查询</el-button>
                    <el-button type="success" @click="handleAddRoleResource">新增</el-button>
                    <el-button type="warning" @click="dialogFormVisible1 = false">关闭</el-button>
                </el-form-item>
            </el-form>
            <el-table :data="dataList1" stripe border center :size="GCONFIG.styleTableSize"  v-loading="loading1">
                <el-table-column type="index" label="序号" width="50"></el-table-column>
                <el-table-column prop="roleName" label="角色名称"></el-table-column>
                <el-table-column prop="resourceName" label="资源名称"></el-table-column>
                <el-table-column prop="resourceHtmlUrl" label="菜单路径"></el-table-column>
                <el-table-column prop="resourceUrl" label="资源路径"></el-table-column>
                <el-table-column label="操作" fixed="right" width="160">
                    <template slot-scope="scope">
                        <el-button type="warning " size="mini" @click="handleDeleteRoleResource(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-wrap">
                <el-pagination
                        background
                        @size-change="handleSizeChange1"
                        @current-change="handleCurrentChange1"
                        :current-page="formInline1.currentPage"
                        :page-sizes="GCONFIG.pageSizes"
                        :page-size="formInline1.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="formInline1.recordsTotal">
                </el-pagination>
            </div>


            <el-dialog title="资源添加" :visible.sync="dialogFormVisible2" center  append-to-body>
                <el-form :inline="true" :model="formInline2" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize">
                    <el-form-item>
                        <el-button type="primary" @click="getResourceList">查询</el-button>
                        <el-button type="success" @click="handleAddRoleResourcesave">保存</el-button>
                        <el-button type="warning" @click="dialogFormVisible2 = false">关闭</el-button>
                    </el-form-item>
                </el-form>
                <el-table :data="dataList2" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading2" @selection-change="handleSelectionChange">
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column type="index" label="序号" width="50"></el-table-column>
                    <el-table-column prop="resourceId" label="资源标示"></el-table-column>
                    <el-table-column prop="resourceName" label="名称"></el-table-column>
                    <el-table-column prop="resourceType" :formatter="convertType" label="类型"></el-table-column>
                    <el-table-column prop="resourceHtmlUrl" label="菜单路径"></el-table-column>
                    <el-table-column prop="resourceUrl" label="资源路径"></el-table-column>
                    <el-table-column prop="resourceOrder" label="排序" sortable></el-table-column>
                 </el-table>
                <div class="pagination-wrap">
                    <el-pagination
                            background
                            @size-change="handleSizeChange2"
                            @current-change="handleCurrentChange2"
                            :current-page="formInline2.currentPage"
                            :page-sizes="GCONFIG.pageSizes"
                            :page-size="formInline2.pageSize"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="formInline2.recordsTotal">
                    </el-pagination>
                </div>
            </el-dialog>
        </el-dialog>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import {
        saveOrUpdateMallRole,
        getMallRoleList,
        allPlatFormGroupList,
        getMallRoleResourceList,
        saveRoleResource,
        deleteRoleResource,
        getMallParentResourceList,
        getMallleafResourceList,
    } from '../../api/api'


    //定义组件
    export default {
        data() {
            return {
                dataList: [],
                dataList1: [],
                dataList2: [],
                platFormGroupList:[],
                statusList: [{value: 1, name: '有效'}, {value: -1, name: '无效'}],
                loading: true,
                loading1: true,
                loading2: true,
                dialogFormVisible: false,
                dialogFormVisible1: false,
                dialogFormVisible2: false,
                formInline: {
                    roleName: "",
                    currentPage: 1,
                    pageSize: 15,
                    recordsTotal: 0,
                },
                formInline1: {
                    roleId: "",
                    resourceType:1,
                    currentPage: 1,
                    pageSize: 15,
                    recordsTotal: 0,
                },
                formInline2: {
                    roleId: "",
                    resourceId:0,
                    resourceType:1,
                    currentPage: 1,
                    pageSize: 10,
                    recordsTotal: 0,
                },
                form: {
                    roleId: '',
                    roleName: '',
                    platformGroupId: '',
                    status:1,
                },
                form2: {
                    roleId: '',
                    resourceIds: [],
                },
            }
        },
        //挂载时候执行
        mounted() {
            this.getList();
            allPlatFormGroupList().then((res) => {
                this.platFormGroupList = res.data;
            })
        },
        methods: {
            //定义查询方法
            getList() {
                this.loading = true;
                getMallRoleList(this.formInline).then((res) => {
                    this.loading = false;
                    if (res.data.status == 200) {
                        this.$message({
                            showClose: true,
                            message: '查询成功',
                            type: 'success'
                        });
                        this.formInline.recordsTotal = res.data.value.total;
                        this.dataList = res.data.value.list;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getList()
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getList()
            },
            handleAdd() {
                this.form= {
                    roleId: '',
                    roleName: '',
                    platformGroupId: '',
                    status:1,
                }
                this.dialogFormVisible = true;
            },
            handleUpdate(row) {
                this.form= {
                    roleId:row.roleId,
                    roleName: row.roleName,
                    platformGroupId: row.platformGroupId,
                    status:row.status,
                }
                this.dialogFormVisible = true;
            },
            updateOrAdd() {
                const loading = this.$loading(this.GCONFIG.loadingParam);
                saveOrUpdateMallRole(this.form).then((res) => {
                    loading.close();
                    if (res.data.status == 200) {
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                        this.getList();
                        this.dialogFormVisible = false;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            convertStatus(row, column, cellValue) {
                if (row.status == 1) {
                    return "有效";
                } else {
                    return "无效";
                }
            },
            handleResource(row){
                this.dialogFormVisible1=true;
                this.formInline1.resourceType=2;
                this.formInline1.roleId=row.roleId;
                this.formInline2.roleId=row.roleId;
                this.getMallRoleResourceList();
            },
            handleMenu(row){
                this.dialogFormVisible1=true;
                this.formInline1.resourceType=1;
                this.formInline1.roleId=row.roleId;
                this.formInline2.roleId=row.roleId;
                this.getMallRoleResourceList();
            },
            getMallRoleResourceList() {
                this.loading1 = true;
                getMallRoleResourceList(this.formInline1).then((res) => {
                    this.loading1 = false;
                    if (res.data.status == 200) {
                        this.$message({
                            showClose: true,
                            message: '查询成功',
                            type: 'success'
                        });
                        this.formInline1.recordsTotal = res.data.value.total;
                        this.dataList1 = res.data.value.list;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            handleSizeChange1(val) {
                this.formInline1.pageSize = val;
                this.getMallRoleResourceList()
            },
            handleCurrentChange1(val) {
                this.formInline1.currentPage = val;
                this.getMallRoleResourceList()
            },
            handleDeleteRoleResource(row){
                this.$confirm('删除, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    const loading = this.$loading(this.GCONFIG.loadingParam);
                    deleteRoleResource({id:row.id}).then((res) => {
                        loading.close();
                        if(res.data.status==200){
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            this.getMallRoleResourceList();
                        }else{
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    })
                }).catch(() => {});
            },
            handleAddRoleResource() {
                this.dialogFormVisible2 = true;
                this.form2.roleId=this.formInline1.roleId;
                this.formInline2.resourceType=this.formInline1.resourceType;
                this.getResourceList();
            },

            getResourceList() {
                if(this.formInline2.resourceType==1){
                    //菜单
                    this.loading2 = true;
                    getMallleafResourceList(this.formInline2).then((res) => {
                        this.loading2 = false;
                        if (res.data.status == 200) {
                            this.$message({
                                showClose: true,
                                message: '查询成功',
                                type: 'success'
                            });
                            this.formInline2.recordsTotal = res.data.value.total;
                            this.dataList2 = res.data.value.list;
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    })
                }else{
                    //资源
                    this.loading2 = true;
                    getMallParentResourceList(this.formInline2).then((res) => {
                        this.loading2 = false;
                        if (res.data.status == 200) {
                            this.$message({
                                showClose: true,
                                message: '查询成功',
                                type: 'success'
                            });
                            this.formInline2.recordsTotal = res.data.value.total;
                            this.dataList2 = res.data.value.list;
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    })
                }
            },
            handleSizeChange2(val) {
                this.formInline2.pageSize = val;
                this.getResourceList()
            },
            handleCurrentChange2(val) {
                this.formInline2.currentPage = val;
                this.getResourceList()
            },
            handleAddRoleResourcesave(){
                const loading = this.$loading(this.GCONFIG.loadingParam);
                saveRoleResource(this.form2).then((res) => {
                    loading.close();
                    if (res.data.status == 200) {
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                        this.getMallRoleResourceList();
                        this.dialogFormVisible2 = false;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            handleSelectionChange(val) {
                this.form2.resourceIds = val;
            },
            convertType(row, column, cellValue){
                if (row.resourceType == 1) {
                    return "菜单";
                } else {
                    return "资源";
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/sys/role.vue